export class SandboxDomainError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'SandboxDomainError';
  }
}
